import React, { useState, useEffect } from "react";
import { useHookstate } from "@hookstate/core";
import globalAuthStateStore from "../../../../../stores/globalAuthStateStore";
import { VirtualLibrarianService } from "../../../../../services/VirtualLibrarianService";
import virtualLibrarianSettingsStore from "../../../../../stores/virtualLibrarianSettingsStore";

// Import a local SCSS file if you plan to style it, e.g., './chatLogInterface.scss';

const VirtualLibrarianSettings = () => {
  const [showSuccess, setShowSuccess] = useState(false);
  const settings = useHookstate(virtualLibrarianSettingsStore);
  const [numResults, setNumResults] = useState(
    settings.SEARCH_INDEX_COUNT.int_value.get()
  );
  const [returnAllRagResults, setReturnAllRagResults] = useState(
    settings.RETURN_ALL_RAG_RESULTS.bool_value.get()
  );

  const authStore = useHookstate(globalAuthStateStore);
  const vlService = React.useMemo(
    () => new VirtualLibrarianService(authStore),
    [authStore]
  );

  const saveConfigSetting = async () => {
    const indexCountSetting = {
      ...settings.SEARCH_INDEX_COUNT.get(), // Get the existing setting object from the store
      int_value: numResults, // Update its int_value property
    };
    const returnAllRagResultsSetting = {
      ...settings.RETURN_ALL_RAG_RESULTS.get(), // Get the existing setting object from the store
      bool_value: returnAllRagResults, // Update its bool_value property
    };

    const result = await vlService.updateVirtualLibrarianSettings([
      indexCountSetting,
    ]);
    if (result.Success) {
      settings.SEARCH_INDEX_COUNT.set(indexCountSetting);
      settings.RETURN_ALL_RAG_RESULTS.set(returnAllRagResultsSetting);
      setShowSuccess(true);
    }
  };

  // Handlers for input changes
  const handleNumResultsChange = (event) => {
    const value = event.target.value;
    setNumResults(value === "" ? "" : parseInt(value, 10));
  };

  const handleReturnAllResultsChange = (event) => {
    setReturnAllRagResults(event.target.checked);
  };

  // Handler for saving settings
  const handleSaveSettings = async () => {
    if (
      settings.SEARCH_INDEX_COUNT.int_value.get() === "" ||
      isNaN(settings.SEARCH_INDEX_COUNT.int_value.get()) ||
      settings.SEARCH_INDEX_COUNT.int_value.get() < 1 ||
      settings.SEARCH_INDEX_COUNT.int_value.get() > 50
    ) {
      alert("Please enter a valid number of results (between 1 and 50).");
      return;
    }

    await saveConfigSetting({
      setting_name: "SEARCH_INDEX_COUNT",
      int_value: numResults,
    });

    // Show success message
    setShowSuccess(true);
    // Hide success message after 3 seconds
    setTimeout(() => {
      setShowSuccess(false);
    }, 3000);
  };

  return (
    <div
      className="contentDisplay-list"
      style={{ position: "relative", paddingBottom: "80px" }}>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "stretch",
          alignContent: "center",
        }}>
        <h3>Enhanced Search - Settings</h3>
        <div
          style={{
            marginTop: "20px",
            border: "1px solid #e0e0e0",
            padding: "25px",
            borderRadius: "8px",
            backgroundColor: "#ffffff",
            boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
          }}>
          <h4
            style={{
              marginTop: "0",
              marginBottom: "20px",
              color: "#333",
              fontSize: "1.2em",
            }}>
            Chatbot Configuration
          </h4>

          <div style={{ marginBottom: "20px" }}>
            <label
              htmlFor="numRagResults"
              style={{
                display: "block",
                marginBottom: "8px",
                fontWeight: "500",
                color: "#555",
              }}>
              Number of RAG Search Results:
            </label>
            <input
              type="number"
              id="numRagResults"
              value={numResults}
              onChange={handleNumResultsChange}
              min="1"
              max="50"
              style={{
                padding: "10px",
                borderRadius: "4px",
                border: "1px solid #ccc",
                width: "100px",
                fontSize: "1em",
              }}
              onWheel={(e) => e.target.blur()}
            />
            <p
              style={{
                fontSize: "0.85em",
                color: "#777",
                margin: "8px 0 0 0",
              }}>
              Number of documents/chunks retrieved for context (Default: 6, Min:
              1, Max: 50).
            </p>
          </div>

          <div style={{ marginBottom: "25px" }}>
            <div style={{ display: "flex", alignItems: "center" }}>
              <input
                type="checkbox"
                id="returnAllRagResults"
                checked={returnAllRagResults}
                onChange={handleReturnAllResultsChange}
                style={{
                  marginRight: "10px",
                  transform: "scale(1.3)",
                  cursor: "pointer",
                  accentColor: "#007bff",
                }}
              />
              <label
                htmlFor="returnAllRagResults"
                style={{ fontWeight: "500", color: "#555", cursor: "pointer" }}>
                Return all retrieved RAG results (Resets after the session and
                applies to Admin Playground only)
              </label>
            </div>
            <p
              style={{
                fontSize: "0.85em",
                color: "#777",
                margin: "8px 0 0 0",
                paddingLeft: "calc(1.3em + 10px)",
              }}>
              If checked, all search results from RAG will be available, even if
              not directly cited in the Enhanced Search's response.
            </p>
          </div>

          <div style={{ display: "flex", alignItems: "center", gap: "15px" }}>
            <button
              onClick={handleSaveSettings}
              style={{
                padding: "10px 20px",
                backgroundColor: "#007bff",
                color: "white",
                border: "none",
                borderRadius: "5px",
                cursor: "pointer",
                fontSize: "1em",
                fontWeight: "500",
                transition: "background-color 0.2s ease",
              }}
              onMouseOver={(e) => (e.target.style.backgroundColor = "#0056b3")}
              onMouseOut={(e) => (e.target.style.backgroundColor = "#007bff")}>
              Save Settings
            </button>
            <span
              style={{
                color: "#28a745",
                opacity: showSuccess ? 1 : 0,
                transition: "opacity 0.3s ease-in-out",
                fontSize: "14px",
                fontWeight: "500",
              }}>
              Settings Saved!
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VirtualLibrarianSettings;
